import * as React from 'react';
import { ApplicationContext } from '../../../ApplicationContext';
import { getCategoryInfo } from '../../../../utils';
import { useSelector } from 'react-redux';
import { selectIsByHomeowner, selectOfferCategory } from '../../../../selectors/offer';
import { useMemo } from 'react';

enum EBanners {
  DEMAND_TRAP = 'DEMAND_TRAP',
}

const getRandomBanner = (banners: EBanners[]) => {
  return banners[Math.floor(banners.length * Math.random())];
};

export const useShowBanner = () => {
  const { config } = React.useContext(ApplicationContext);
  const isDemandTrapEnabled = config.get<boolean>('demand.DemandTrapBannerEnabled');

  const isHomeowner = useSelector(selectIsByHomeowner);
  const category = getCategoryInfo(useSelector(selectOfferCategory));

  const isRentByHomeowner = isHomeowner && category.dealType === 'rent';

  const banners = useMemo(
    () => [
      {
        name: EBanners.DEMAND_TRAP,
        available: isDemandTrapEnabled,
      },
    ],
    [isDemandTrapEnabled],
  );

  const availableBanners = useMemo(() => banners.filter(item => item.available).map(item => item.name), [banners]);

  const randomBanner = getRandomBanner(availableBanners);

  const showDemandTrapBanner = (isRentByHomeowner && isDemandTrapEnabled) || randomBanner === EBanners.DEMAND_TRAP;

  return { showDemandTrapBanner, category };
};
